import { DataTableColumn } from "./DataTable";
import { Accessor } from "react-table";
import { KeyedAccessor } from "./useFilterableRows";

function getAccessors<T>(columns: DataTableColumn<T>[]): KeyedAccessor[] {
    return columns.reduce((previous: KeyedAccessor[], current: DataTableColumn<T>) => {
        if (current.accessor && current.key && !Array.isArray(current.accessor)) { 
            previous.push({ accessor: current.accessor, key: current.key })
        }
        return previous;
    },[])
}

export default getAccessors